import { Capacitor } from '@capacitor/core';
import { Preferences } from '@capacitor/preferences';
import { App } from '@capacitor/app';
import { Device } from '@capacitor/device';
import { v4 as uuid } from 'uuid';
import { RegisterDevicePayload } from '../models/core/device.models';

const KEY_INSTALLATION_ID = 'installation_id';
const KEY_SERVER_DEVICE_ID = 'server_device_id';

export async function ensureInstallationId(): Promise<string> {
	const existing = await Preferences.get({ key: KEY_INSTALLATION_ID });
	if (existing.value) return existing.value;
	const id = uuid();
	await Preferences.set({ key: KEY_INSTALLATION_ID, value: id });
	return id;
}

export async function saveServerDeviceId(id: string | number): Promise<void> {
	const idStr = String(id);
	await Preferences.set({ key: KEY_SERVER_DEVICE_ID, value: idStr });
}

export async function getServerDeviceId(): Promise<string | null> {
	const { value } = await Preferences.get({ key: KEY_SERVER_DEVICE_ID });
	return value ?? null;
}

export async function clearServerDeviceId(): Promise<void> {
	await Preferences.remove({ key: KEY_SERVER_DEVICE_ID });
}

export async function collectDeviceContext(): Promise<
	Pick<RegisterDevicePayload, 'platform' | 'app_version' | 'app_build' | 'timezone' | 'os_version' | 'device_model'> & { locale: string }
> {
	const platformId = Capacitor.getPlatform();
	const platform = platformId === 'ios' ? 'ios' : 'android';
	const appInfo = await App.getInfo();
	const devInfo = await Device.getInfo();
	const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
	const locale = navigator.language;

	return {
		platform,
		app_version: appInfo.version,
		app_build: Number(appInfo.build) || undefined,
		timezone,
		os_version: devInfo.osVersion,
		device_model: devInfo.model,
		locale,
	};
}


